var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4535,
    cy: 22.4535,
    r: 22.4535,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1411 15.7309H29.9936V18.5834H27.1411V15.7309Z",
    fill: "#FFCA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1411 20.0097H29.9936V22.8622H27.1411V20.0097Z",
    fill: "#FFCA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8623 15.7309H25.7148V18.5834H22.8623V15.7309Z",
    fill: "#FFCA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8623 20.0097H25.7148V22.8622H22.8623V20.0097Z",
    fill: "#FFCA00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0795 29.2805C21.6702 29.2805 22.1492 28.8015 22.1492 28.2108C22.1492 27.62 21.6702 27.1411 21.0795 27.1411C20.4887 27.1411 20.0098 27.62 20.0098 28.2108C20.0098 28.8015 20.4887 29.2805 21.0795 29.2805Z",
    fill: "#2176FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7148 32.133H16.4441C16.0659 32.1326 15.7034 31.9822 15.436 31.7148C15.1686 31.4474 15.0182 31.0849 15.0178 30.7067V13.5915C15.0182 13.2133 15.1686 12.8508 15.436 12.5834C15.7034 12.316 16.0659 12.1656 16.4441 12.1652H25.7148V13.5915H16.4441V30.7067H25.7148V25.0016H27.1411V30.7067C27.1407 31.0849 26.9903 31.4474 26.7229 31.7148C26.4555 31.9822 26.093 32.1326 25.7148 32.133Z",
    fill: "#2176FF",
    stroke: "#2176FF",
    strokeWidth: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobApp);
export default __webpack_public_path__ + "static/media/mobApp.517387fa5740a856db2569f48aa32607.svg";
export { ForwardRef as ReactComponent };